import { formatUnits } from "viem";
import { formatBalance } from "../../../helper";
import useWallet from "../../../hooks/useWallet";

export default function StakeTab({
  tokenBalance,
  tokenSymbol,
  tokenDecimals = 18, // 👈 pass this if available
  value,
  handleChange,
  totalStakedFormatted,
  rewardsFormatted,
  openModal,
  setValue,
  isRootPoolActive,
}) {
  const { address } = useWallet();

  // Convert user's input to numeric
  const numericValue = Number(value?.toString().replace(/,/g, "")) || 0;

  // Convert raw balance (BigInt/string) to plain numeric value
  const balanceNumber = Number(formatUnits(tokenBalance || 0n, tokenDecimals));

  // Disable button if invalid input, <= 0, or > balance
  const isDisabled =
    !numericValue ||
    numericValue <= 0 ||
    numericValue > balanceNumber ||
    !isRootPoolActive;

  return (
    <div className="top_one">
      <div className="inner_top">
        <h3>Enter Staking Amount</h3>
        <h4>
          Balance:{" "}
          <span>
            {address
              ? `${formatBalance(tokenBalance, tokenDecimals)} ${tokenSymbol}`
              : `0 ${tokenSymbol}`}
          </span>
        </h4>
      </div>

      <div className="input_div">
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder="0.00"
        />
        <div
          className="inter_div"
          onClick={() =>
            setValue(formatUnits(tokenBalance || 0n, tokenDecimals))
          }
        >
          <span>MAX</span>
          <div className="inter_text">
            <h5 className="outter_sec">{tokenSymbol}</h5>
          </div>
        </div>
      </div>

      {/* <h6>
        Minimum Stake <span className="whitte">1 {tokenSymbol}</span>
      </h6> */}

      <button
        onClick={() => openModal("stakeFinalize")}
        disabled={isDisabled}
        style={{
          opacity: isDisabled ? 0.6 : 1,
          cursor: isDisabled ? "not-allowed" : "pointer",
        }}
      >
        Stake
      </button>
    </div>
  );
}
